var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flair",class:{displayed: _vm.displayed},on:{"click":_vm.emitClick}},[_c('div',{staticClass:"flair-frame",class:{shown: _vm.shown}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }